// Function to trigger a function before the target enters the viewport. You must specify a target his id and the function to run.

function sauron(target, id, myFunction) {
  //   let targets = document.querySelectorAll('[data-target="observed"]');
  //   targets.forEach((elem) => {
  let observerOptions = {
    root: null,
    rootMargin: "50%",
    threshold: 0,
  };
  let observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      // Each entry describes an intersection change for one observed
      // target element:
      //   entry.boundingClientRect
      //   entry.intersectionRatio
      //   entry.intersectionRect
      //   entry.isIntersecting
      //   entry.rootBounds
      //   entry.target
      //   entry.time
      if (entry.isIntersecting) {
        // SCROLL TO TOP BUTTON
        entry.target.dataset.id == `${id}` ? myFunction() : null;
      }
    });
  };
  let observer = new IntersectionObserver(observerCallback, observerOptions);

  observer.observe(target);
  //   });
}

export default sauron;
